import { tns } from 'tiny-slider/src/tiny-slider';

class ImageGallerySlider {
	constructor(el, prevButton, nextButton, nav) {
		console.log(this.nav);
		this.el = el;
		this.prevButton = prevButton;
		this.nextButton = nextButton;
		this.nav = nav;

		const imageGallerySlider = tns({
			container: this.el,
			autoplay: true,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: false,
			prevButton: this.prevButton,
			nextButton: this.nextButton,
			nav: false,
			navPosition: "bottom",
			navContainer: this.nav
		});

		return imageGallerySlider;

	}
}

export default ImageGallerySlider;